import template from './bargain-daily.jade';
import validation from './../../../services/validation';

export default angular.module('cian.addForm.bargainDaily', []).directive('cianAfPriceAndDealTermsBargainDaily', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
  },
  controller: [
    '$scope',
    'deviceService',
    function ($scope, deviceService) {
      this.isMobile = deviceService.isMobile;
      const isBargainAllowed = () => {
        return (
          this.ad.bargainTerms.bargainAllowed ||
          (angular.isDefined(this.ad.bargainTerms.bargainPrice) && this.ad.bargainTerms.bargainPrice !== null) ||
          angular.isString(this.ad.bargainTerms.bargainConditions)
        );
      };

      this.ad.bargainTerms = this.ad.bargainTerms || {};
      this.ad.bargainTerms.bargainAllowed = isBargainAllowed();

      $scope.$watch(
        () => this.ad.bargainTerms.bargainAllowed,
        (newValue, oldValue) => {
          if (newValue === false && oldValue === true) {
            if (this.ad.bargainTerms.bargainConditions) {
              delete this.ad.bargainTerms.bargainConditions;
            }
            if (this.ad.bargainTerms.bargainPrice) {
              delete this.ad.bargainTerms.bargainPrice;
            }
          }
        },
      );

      this.validation = validation(this.form, 'bargainDaily.bargainConditions', {
        maxlength: 'Превышено ограничение',
      });
    },
  ],
  controllerAs: 'bargainDaily',
  template,
})).name;
